import React from "react";
import { connect } from "react-redux";
import { crearPlanMovilidad } from "../actions";
import { scrollElementToTop } from "../functions";

class FinalizarSeguimientoPlanMovilidad extends React.PureComponent {

  componentDidMount = () => {
    scrollElementToTop("finalizar_seguimiento_planmovilidad");
  }

  render() {
    return (
      <section id="finalizar_seguimiento_planmovilidad">
        <div className="container-fluid">
          <div className="row PM-plan-borde-spacing">
            <div className="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center">
              <div className="col-md-8 p-lg-5 mx-auto my-5 cuadro-1">
                <div className="row col-md-12 PM-tipo-denuncias-select PM-plan-exito">
                  <div className="col-md-12 text-center">
                    <span className="PM-felicita"><strong>¡Felicitaciones!</strong></span>
                  </div>
                  <div className="col-md-12 text-center PM-section-title">Finalizaste la etapa de ejecución y seguimiento del plan de movilidad Traslado Seguro</div>
                  <div className="col-md-12 text-center PM-info">
                    <p>Gracias por el compromiso mostrado durante la implementación del plan.</p>
                    <p>Si quieres seguir contribuyendo a que los trabajadores del centro de trabajo lleguen a sus trabajos y de regresos a sus casas sin novedad, te invitamos a realizar un nuevo Plan de Movilidad con información actualizada.</p>
                  </div>
                </div>
                <div className="PM-home-item_plan PM-plan-contador-finalizar">
                  <button
                    className="btn PM-dx-button-plan PM-dx-button-plan-100"
                    onClick={() => { this.props.dispatch(crearPlanMovilidad(this.props.companyId, this.props.companyName, this.props.sucursalId, this.props.sucursalName, this.props.usuarioRUT, this.props.usuarioNombre, this.props.usuarioApellido, this.props.usuarioEmail)); }}
                  >Configurar otro plan
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="PM-footer">&nbsp;</div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  sucursalId: state.global.sucursalId,
  sucursalName: state.global.sucursalName,
  companyId: state.global.companyId,
  companyName: state.global.companyName,
  usuarioRUT: state.global.userData.RUT,
  usuarioNombre: state.global.userData.FirstName,
  usuarioApellido: state.global.userData.LastName,
  usuarioEmail: state.global.userData.Email,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalizarSeguimientoPlanMovilidad);
